import React from 'react';
import PropTypes from 'prop-types';

import BlurhashCanvas from './panda-view-simple-previews/blurhash-canvas';
import PhotoPreviewPlaceholder from './panda-view-simple-previews/photo-preview-placeholder';
import { usePrintsConfigStore } from '../stores';

/**
 * What a tile shows in place of PandaView once every thumbnail URL has failed: the photo's
 * blurhash where there is one, otherwise a placeholder carrying its filename.
 *
 * Returns the preview element itself with no wrapper, because preview-sizing targets
 * `canvas` and `.photo-preview-placeholder` directly and an intermediate box breaks the
 * sizing those rules rely on.
 */
const FailedPhotoPreview = ({
  blurhash,
  rawDimensions,
  sizeArea,
  fx,
  filename,
}) => {
  const { printsBuilderBlurhashDisabled } = usePrintsConfigStore(
    (state) => state.features,
  );

  // A photo can still carry a hash after the kill switch is turned on, so check the flag
  // rather than inferring from the hash being absent.
  const showBlurhash = !!(blurhash && !printsBuilderBlurhashDisabled);

  if (showBlurhash) {
    return (
      <BlurhashCanvas
        hash={blurhash}
        rawDimensions={rawDimensions}
        sizeArea={sizeArea}
        fx={fx}
      />
    );
  }

  return (
    <PhotoPreviewPlaceholder
      filename={filename}
      rawDimensions={rawDimensions}
      sizeArea={sizeArea}
    />
  );
};

FailedPhotoPreview.propTypes = {
  blurhash: PropTypes.string,
  rawDimensions: PropTypes.shape({
    w: PropTypes.number,
    h: PropTypes.number,
  }),
  sizeArea: PropTypes.arrayOf(PropTypes.number),
  fx: PropTypes.string,
  filename: PropTypes.string,
};

FailedPhotoPreview.defaultProps = {
  blurhash: null,
  rawDimensions: null,
  sizeArea: null,
  fx: null,
  filename: '',
};

export default FailedPhotoPreview;
